import React, { useCallback, useMemo } from 'react';
import DropdownSelect from '@baidu/icloud-ui-dropdown-select';
import { useLocalStorage } from 'huse';
import { string2hash } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";

const CustomerColumns = ({
  columnsIn
}) => {
  // 如果没有dataIndex 比如操作 那么使用title
  // 如果dataIndex 没有 且title还是自定义渲染出来得。那么装作看不见 如果真的需要可以添加 CustomerColumnKey 做key
  const columns = useMemo(() => columnsIn.filter(i => i.dataIndex || typeof i.title === 'string'), [columnsIn]); // 使用columsIn 中dataIndex 属性求hash 做localStorage Key;
  // 不认为一个系统中会存在多个字段完全相同的表格。如果真的需要后续可添加CustomerColumnsCacheKey 做区分；

  const localStroageKey = useMemo(() => string2hash(columns.map(i => i.dataIndex || i.title).join(',')).toString(), [columns]);
  const [customerColumnsStorage, setCustomerColumnsStorage] = useLocalStorage(localStroageKey, null);
  const onChange = useCallback(val => {
    setCustomerColumnsStorage(val);
    const newStorageEvent = new StorageEvent('storage');
    newStorageEvent.initStorageEvent('storage', false, false, localStroageKey, null, JSON.stringify(val), null, window.localStorage);
    window.dispatchEvent(newStorageEvent);
  }, [localStroageKey, setCustomerColumnsStorage]);
  const options = useMemo(() => {
    return columns.map(i => ({
      label: i.title,
      value: i.dataIndex || i.title,
      isChoose: i.isChoose
    }));
  }, [columns]);
  /**
   * 计算逻辑为先从缓存中拿。缓存中没有通过columnsIn计算。
   */

  const value = useMemo(() => {
    return customerColumnsStorage || columns.filter(i => !i.defaultHidden).map(i => i.dataIndex);
  }, [customerColumnsStorage, columns]);
  return /*#__PURE__*/_jsx(DropdownSelect, {
    options: options,
    value: value,
    onChange: onChange
  });
};

export default CustomerColumns;
//# sourceMappingURL=es/CustomerColumns.js.map